import { HiHandRaised } from 'react-icons/hi2';
import { DynamicForm, Modal } from '@src/components';
import { Button, message } from 'antd';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UserChangeRoleSchema } from '@src/formSchemas/user/userChangeRoleSchema';
import { User } from '@src/services/users/usersTypes';
import { useUpdateUserMutation } from '@src/services/users/updateUser/updateUserApiSlice';
import { errorHandler } from '@src/hooks';
import { useNavigate } from 'react-router-dom';
import { UpdateUserParams } from '@src/services/users/updateUser/updateUserApiSliceTypes';
interface ChangeUserRoleModalProps {
    open: boolean;
    onClose: () => void;
    user: User | null;
}
const ChangeUserRoleModal = ({
    open,
    onClose,
    user,
}: ChangeUserRoleModalProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [updateUser, { isLoading: isUpdateUserLoading }] =
        useUpdateUserMutation();
    const onSubmit = async (formData: FieldValues) => {
        try {
            await updateUser({
                id: user?.id,
                roleId: formData.role?.value,
            } as UpdateUserParams).unwrap();
            message.success({
                content: t(`notification.success.update`, {
                    name: t('pages.users.changeRole.title'),
                }),
                className: 'response-success',
                type: 'success',
            });
            onClose();
        } catch (error: any) {
            message.error({
                content: t(errorHandler(error)),
                className: 'response-error',
                type: 'error',
            });
        }
    };
    const addNewRole = () => {
        navigate('/dashboard/user-management/roles/new');
    };
    return (
        <Modal
            title={t('pages.users.changeRole.title')}
            headerIcon={
                <HiHandRaised
                    width={20}
                    height={20}
                    className="fill-secondary"
                />
            }
            width={507}
            isOpen={open}
            onClose={onClose}
            content={
                <DynamicForm
                    formData={{
                        role: { label: user?.roleName, value: user?.roleId },
                    }}
                    formKeyName="change-user-role-form"
                    onHandleSubmit={onSubmit}
                    containerClassNames="grid gap-4 [&_label]:mb-2"
                    formRows={UserChangeRoleSchema({
                        t,
                        addNewRole,
                        user,
                    })}
                />
            }
            footer={
                <div className="w-full flex justify-between text-center space-x-2">
                    <Button
                        size="large"
                        className="btn-secondary w-full justify-center"
                        onClick={onClose}
                        disabled={isUpdateUserLoading}
                    >
                        {t('buttons.cancel')}
                    </Button>
                    <Button
                        size="large"
                        htmlType="submit"
                        className="btn-primary w-full text-center justify-center"
                        form="change-user-role-form_mainform"
                        disabled={isUpdateUserLoading}
                    >
                        {t('buttons.apply')}
                    </Button>
                </div>
            }
        />
    );
};

export default ChangeUserRoleModal;
